export default "__VITE_ASSET__DXOviy$___"